import { IForecastStaff } from '@/coreDomainsModule/entities/forecast';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ForecastStaffFactory } from '../domains/factories/forecastStaffFactory';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 担当者ごとの内示回収状況を取得するUseCase
 */
export class BulkGetForecastForReceiptStaffUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 担当者ごとの内示回収状況を取得する
   * @param receivedYear - 内示受領年
   * @param receivedMonth - 内示受領月
   */
  public async Execute(receivedYear: number, receivedMonth: number): Promise<INetworkResult<IForecastStaff[], Error>> {
    try {
      const result = await this.repository.getForecastForReceiptStaffSummary(receivedYear, receivedMonth);

      switch (result.status.type) {
        case 'success':
          const staffList: IForecastStaff[] = result.status.data.data.map((item) => ({
            forecastStaffId: item.userId,
            forecastStaffName: item.userName,
            recoveredForecastCount: item.recoveredForecastCount,
            totalForecastCount: item.totalForecastCount,
            latestUpdateAt: item.latestUpdateAt ? DateService.convertMSUnixTimeToIDate(item.latestUpdateAt) : undefined,
          }));
          return {
            status: {
              type: 'success',
              data: staffList,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('担当者情報の取得に失敗しました'),
        },
      };
    }
  }

  /**
   * モックデータを返す（テスト用）
   */
  public MockExecute(): Promise<INetworkResult<IForecastStaff[], Error>> {
    const mock1 = ForecastStaffFactory.createWithRequired({
      forecastStaffName: 'A',
      recoveredForecastCount: 1,
      totalForecastCount: 2,
      latestUpdateAt: { year: 2021, month: 1, day: 1 },
    });
    const mock2 = ForecastStaffFactory.createWithRequired({
      forecastStaffName: 'B',
      recoveredForecastCount: 3,
      totalForecastCount: 4,
      latestUpdateAt: { year: 2021, month: 1, day: 2 },
    });
    const mock3 = ForecastStaffFactory.createWithRequired({
      forecastStaffName: 'C',
      recoveredForecastCount: 5,
      totalForecastCount: 6,
      latestUpdateAt: { year: 2021, month: 1, day: 3 },
    });

    return Promise.resolve({
      status: {
        type: 'success',
        data: [mock1, mock2, mock3],
      },
    });
  }
}
